import React, { useState, useEffect, useContext } from 'react';
import { QuoteContext } from '../assets/context/QuoteContext';

function ReceiverEditModal(props) {
    const { saveSRDetails, SRDetails } = useContext(QuoteContext);
    const { isOpen, onClose, onUpdateReceiver } = props;
    
    const [eFormData, eSetFormData] = useState({
        eFirstName: '',
        eLastName: '',
        eEmail: '',
        ePhone: '',
        eAddress1: '',
        eAddress2: '',
        ePickupInstructions: '',
    });

    useEffect(() => {
        const ereceiverData = props.receiverData;
        eSetFormData({
            eFirstName: ereceiverData.firstName || '',
            eLastName: ereceiverData.lastName || '',
            eEmail: ereceiverData.email || '',
            ePhone: ereceiverData.phone || '',
            eAddress1: ereceiverData.address1 || '',
            eAddress2: ereceiverData.address2 || '',
            ePickupInstructions: ereceiverData.pickupInstructions || '',
        });
    }, [props.receiverData]);

    useEffect(() => {
        if (!isOpen) return undefined;
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);
    
    const eHandleChange = (e) => {
        const { name, value } = e.target;
        eSetFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Create updated sender data object
        const updatedReceiverData = {
            firstName: eFormData.eFirstName,
            lastName: eFormData.eLastName,
            email: eFormData.eEmail,
            phone: eFormData.ePhone,
            address1: eFormData.eAddress1,
            address2: eFormData.eAddress2,
            pickupInstructions: eFormData.ePickupInstructions,
        };

        if (!SRDetails) return;

        const updatedSRDetails = {
            ...SRDetails,
            receiverFormData: updatedReceiverData,
        };
        // Save to context
        saveSRDetails(updatedSRDetails);
        
        // Notify parent component of update
        if (onUpdateReceiver) {
            onUpdateReceiver(updatedReceiverData);
        }

        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="cw-modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
            <div className="cw-modal" role="dialog" aria-modal="true" aria-labelledby="receiver-modal-title">
                <div className="cw-modal-header">
                    <div><span className="section-kicker">DESTINATION CONTACT</span><h2 id="receiver-modal-title">Edit delivery details</h2></div>
                    <button type="button" className="cw-modal-close" onClick={onClose} aria-label="Close dialog">×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="cw-modal-body">
                        <p className="cw-modal-copy">Update the person and address receiving this shipment.</p>
                        <div className="cw-form-grid">
                            <label>First name<input type="text" name="eFirstName" placeholder="First name" value={eFormData.eFirstName} onChange={eHandleChange} /></label>
                            <label>Last name<input type="text" name="eLastName" placeholder="Last name" value={eFormData.eLastName} onChange={eHandleChange} /></label>
                            <label className="cw-form-span-2">Email<input type="email" name="eEmail" placeholder="Email address" value={eFormData.eEmail} onChange={eHandleChange} /></label>
                            <label>Phone<input type="tel" name="ePhone" placeholder="Phone number" value={eFormData.ePhone} onChange={eHandleChange} /></label>
                            <label>Address line 1<input type="text" name="eAddress1" placeholder="Street address" value={eFormData.eAddress1} onChange={eHandleChange} /></label>
                            <label className="cw-form-span-2">Address line 2<input type="text" name="eAddress2" placeholder="Apartment, unit, etc. (optional)" value={eFormData.eAddress2} onChange={eHandleChange} /></label>
                            <label className="cw-form-span-2">Delivery instructions<textarea name="ePickupInstructions" placeholder="Anything your driver should know?" value={eFormData.ePickupInstructions} onChange={eHandleChange} rows="3" /></label>
                        </div>
                    </div>
                    <div className="cw-modal-footer">
                        <button type="button" className="btn btn-stroked" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-rnd">Save delivery details <span aria-hidden="true">↗</span></button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ReceiverEditModal;